export default __webpack_public_path__ + "static/media/multiple.21a8afae.png";